import React, { useState } from "react";
import "./PaymentCard.css";

function PaymentCard({ food, isNegative, hidePrice }) {
  const { title, price, quantity, category, brand } = food;

  // Handle price with proper validation and fallbacks
  const safePrice = parseFloat(price || food.salesprice || 0);
  const safeQuantity = parseInt(quantity || 0);
  const totalPrice = isNaN(safePrice) || isNaN(safeQuantity) ? 0 : safePrice * safeQuantity;

  return (
    <div className="payment__card">
      <div className="payment__image__container">🍼</div>

      <div className="payment__card__title">
        <div className="payment__title">
          <span className="payment__card_quantity">{safeQuantity}x</span> {brand || ""}{" "}
          {category || ""} {title || food.name || food.product_name || "Unknown Item"}
        </div>
      </div>

      {hidePrice ? (
        ""
      ) : (
        <div className="payment__card__total">
          <span className="payment__card__price">
            {isNegative ? <span>-</span> : ""}${Math.abs(totalPrice || 0).toFixed(2)}
          </span>
        </div>
      )}
    </div>
  );
}

export default PaymentCard;
